import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Pages from "./Pages";
import "./Assets/styles.css";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

ReactDOM.render(<Pages />, document.getElementById("root"));
